import { useTranslation } from "react-i18next";
import { IResv } from "interface/mypage";
import BookCard from "./bookCard";

import "../mypage.scss";
import "./book.scss";

type IProps = {
  resvs: IResv[];
};

export default function MyBook({ resvs }: IProps) {
  const { t } = useTranslation();

  return (
    <div
      className={resvs && resvs.length === 0 ? "no-list" : ""}
      data-txt={t("bk_no_data_info_bk")}
    >
      {resvs &&
        resvs.map((item, index) => {
          return <BookCard resvInf={item} key={index} lodVisible={false} />;
        })}
    </div>
  );
}
